import React from "react";
import { Link } from "react-router-dom";

import { getUserState, getUserType, renderLicenceBar } from "../../utils/Tools";

function Card(props) {
  const { data, mode } = props;
  const cssClasses = ["card", mode];

  if (Boolean(data.isDeleted)) cssClasses.push("deleted");

  const generateHeader = () => {
    let classes = ["card-header"];
    if (mode === "user") classes.push(data.type);
    if (mode === "client") classes.push(data.type);
    return (
      <>
        <header className={classes.join(" ")}>
          <h2 className="card-header-title">{mode === "user" ? getUserType(data.type) : data.name}</h2>
        </header>
      </>
    );
  };

  const generateContent = () => {
    switch (mode) {
      case "client":
        return (
          <>
            <p>
              {data.contact.firstname} {data.contact.lastname}
              <br />
              {data.contact.email}
              <br />
              {data.address.zipCode} {data.address.city}
            </p>
            <div className="client-status">
              <span className="icon">
                <i className={getUserState(data.isActivated, Boolean(data.isDeleted)).icon}></i>
              </span>
            </div>
            {data.licences && <>{renderLicenceBar(data.licences)}</>}
          </>
        );
      case "institution":
        return (
          <>
            <p className="label">Ansprechpartner</p>
            <p>
              {data.contact.firstname} {data.contact.lastname}
              <br />
              {data.contact.email}
              <br />
              {data.address.zipCode} {data.address.city}
            </p>
            {data.navType !== "lizensierender-mandant" && (
              <div className="client-status">
                <span className="icon">
                  <i className={getUserState(data.isActivated, Boolean(data.isDeleted)).icon}></i>
                </span>
              </div>
            )}
            {renderLicenceBar(data.licences)}
          </>
        );
      case "user":
        return (
          <>
            <p>
              {data.firstname} {data.lastname}
              <br />
              {data.email}
            </p>
            <div className="client-status">
              <span className="icon">
                <i className={getUserState(data.isActivated, Boolean(data.isDeleted)).icon}></i>
              </span>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  const onDelete = e => {
    // Delete button clicked
    if(props.onDelete) props.onDelete(data._id);
  };

  const notDeletable = () => {
    if (mode === "institution" && data.interestGroup === "self") return true;
    if (Boolean(data.isDeleted)) return true;
    return false;
  };

  // let notDeletable = mode === "institution" && data.interestGroup === "self" ? true : false;

  return (
    <div className={cssClasses.join(" ")}>
      {generateHeader()}
      <div className="card-content">{generateContent()}</div>
      <footer className="card-footer">
        <Link className="card-footer-item" to={`/${mode}/${data._id}`}>
          Details
        </Link>
        {!notDeletable() && (
          <button className="card-footer-item" onClick={onDelete} disabled={notDeletable()}>
            Löschen
          </button>
        )}
      </footer>
    </div>
  );
}
export default Card;
